import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ProjectThumbnail from 'components/project_layout/project_thumbnail';

import SelectableRow from 'components/selectable_record_table/selectable_row';

const imageStyle = {
  width: "70px",
  height: "51px"
};

export default class AssignmentRow extends React.Component {
  static propTypes = {
    assignment: PropTypes.shape({
      collaborators: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        imageUrl: PropTypes.string,
        name: PropTypes.string
      })).isRequired,
      listing: PropTypes.shape({
        addressSummary: PropTypes.string,
        statusLabel: PropTypes.string.isRequired,
        statusPillClass: PropTypes.string.isRequired,
        requirement: PropTypes.shape({
          assetTypeLabel: PropTypes.string,
          assignmentTitle: PropTypes.string,
          assignmentTypeLabel: PropTypes.string,
          locationLabel: PropTypes.string
        }).isRequired
      }).isRequired,
      showPath: PropTypes.string.isRequired,
      thumbnailUrl: PropTypes.string.isRequired
    })
  };

  render() {
    const { collaborators, listing, showPath, thumbnailUrl } = this.props.assignment;
    const { assetTypeLabel, assignmentTitle, assignmentTypeLabel, locationLabel } = listing.requirement;

    return (
      <SelectableRow hideCheckbox={true}>
        <td>
          <ProjectThumbnail imageStyle={imageStyle} thumbnailUrl={thumbnailUrl} />
        </td>
        <td>
          <div
            className={`label pill-label ${listing.statusPillClass.replace('_', '-')}`}
            name="listing-status-pill"
          >
            {listing.statusLabel}
          </div>
        </td>
        <td>
          <a href={showPath}>{assignmentTitle}</a>
          {listing.addressSummary && <div className="text-muted">{listing.addressSummary}</div>}
        </td>
        <td>{assignmentTypeLabel}</td>
        <td>{assetTypeLabel}</td>
        <td>{locationLabel}</td>
        <td>
          {collaborators.map(user => (
            <OverlayTrigger key={user.id} overlay={this.renderTooltip(user)} placement="bottom">
              <img className="img-circle" src={user.imageUrl} style={{ width: 30, height: 30 }}/>
            </OverlayTrigger>
          ))}
        </td>
      </SelectableRow>
    );
  }

  renderTooltip(user) {
    return <Tooltip id={`user-${user.id}`}>{user.name}</Tooltip>;
  }
}
